import React from "react";

const HubSpotMeetingIframe = ({
  height = "690",
  source = "",
  width = "100%",
}: {
  height?: string;
  source: string;
  width?: string;
}) => (
  <iframe title="hubspot meeting" width={width} height={height} src={source} />
);

export default HubSpotMeetingIframe;
